import React, { useState } from 'react';

const EyeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
);

const EyeOffIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M10.6 10.6A3 3 0 0 0 13.4 13.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M9.9 5.1A11.2 11.2 0 0 1 12 5c6.5 0 10 7 10 7a19 19 0 0 1-3.3 4.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.2 6.2A19.7 19.7 0 0 0 2 12s3.5 7 10 7c1.6 0 3-.3 4.3-.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const PasswordField = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    required = false,
    className = 'form-control',
    inputClassName = '',
    inputStyle = {},
    showPasswordLabel = 'Show password',
    hidePasswordLabel = 'Hide password'
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="mb-3">
            {label && (
                <label className="form-label fw-bold" htmlFor={name}>
                    {label}
                </label>
            )}
            <div className="input-group">
                <input
                    id={name}
                    type={showPassword ? 'text' : 'password'}
                    className={`${className} ${inputClassName}`.trim()}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    required={required}
                    style={inputStyle}
                />
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? hidePasswordLabel : showPasswordLabel}
                    title={showPassword ? hidePasswordLabel : showPasswordLabel}
                >
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
            </div>
        </div>
    );
};

export default PasswordField;
